/**
 * @voltxampere/ui — Servo motor SG90 variant (Sprint 44-7, placeholder)
 *
 * PLACEHOLDER. PWM-controlled hobby servo motor — mevcut
 * `voltage-source` stamp üzerinden 5V coil drive gösterir.
 * Gerçek PWM duty cycle → angle mapping + iç DC motor + reduktör +
 * pozisyon feedback Sprint 47+ engine extension #4 ile.
 *
 * Reference: TowerPro SG90 — 9 g micro servo. V = 4.8-6 V, akım
 * 10 mA boş 700 mA stall, tork 1.8 kg·cm. PWM 50 Hz, pulse genişliği
 * 1-2 ms (1.5 ms = 0°). Hobbyist + drone + RC + Arduino projeleri.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType (placeholder coil drive).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const motorServoSg90 = {
    id: "motor-servo-sg90",
    nameTr: "Servo SG90 (PWM, 5V, placeholder)",
    nameEn: "Servo SG90 (PWM, 5V, placeholder)",
    shortcut: "V",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "M",
    defaultValue: "SG90",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=motor-servo-sg90.js.map